module.exports = __webpack_public_path__ + "img/vertical_7_4_9005.f04ea4d5.png";